import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CategoryWithProducts } from '../../services/api.service';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-category-grid',
    templateUrl: './category-grid.component.html',
    styleUrls: ['./category-grid.component.scss'],
    standalone: false
})
export class CategoryGridComponent implements OnChanges {
  @Input() categories: CategoryWithProducts[] = [];
  @Output() categoryTapped = new EventEmitter<CategoryWithProducts>();
  currentLang: string = '';

  // Category thumbnail load state — drives the blinking-shadow placeholder.
  private loadedImages = new Set<number>();

  constructor(private languageService: LanguageService) {
    this.languageService.currentLang$.subscribe(lang => {
      this.currentLang = lang;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // A new category set means the thumbnails reload — clear the loaded flags.
    if (changes['categories']) {
      this.loadedImages.clear();
    }
  }

  onImageLoad(id: number): void { this.loadedImages.add(id); }
  onImageError(id: number): void { this.loadedImages.add(id); }
  isImageLoaded(id: number): boolean { return this.loadedImages.has(id); }

  onCategoryClick(category: CategoryWithProducts): void {
    this.categoryTapped.emit(category);
  }

  getCategoryName(category: CategoryWithProducts): string {
    return this.languageService.localizeJsonMap(category.description, category.name || '');
  }

  getCategoryImage(category: CategoryWithProducts): string | null {
    return category.image?.src || null;
  }

  getProductCount(category: CategoryWithProducts): number {
    let count = category.products?.length || 0;
    if (category.subcategories) {
      for (const sub of category.subcategories) {
        count += sub.products?.length || 0;
      }
    }
    return count;
  }
}
